
export const EXCEPTIONS_SET = 'EXCEPTIONS_SET'
export const EXCEPTIONS_FETCHING = 'EXCEPTIONS_FETCHING'
export const EXCEPTIONS_FILTERS = 'EXCEPTIONS_FILTERS'
export const EXCEPTIONS_FETCHING_ERROR = 'EXCEPTIONS_FETCHING_ERROR'
export const EXCEPTIONS_NEXT_PAGE = 'EXCEPTIONS_NEXT_PAGE'
export const EXCEPTIONS_PREV_PAGE = 'EXCEPTIONS_PREV_PAGE'
export const EXCEPTIONS_CLEAR = 'EXCEPTIONS_CLEAR'
